var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5 15C30.5 6.71573 23.7843 0 15.5 0C7.21573 0 0.5 6.71573 0.5 15C0.5 22.4869 5.98528 28.6925 13.1562 29.8177V19.3359H9.34766V15H13.1562V11.6953C13.1562 7.93593 15.3957 5.85937 18.8219 5.85937C20.4631 5.85937 22.1797 6.15234 22.1797 6.15234V9.84375H20.2882C18.4249 9.84375 17.8438 11 17.8438 12.1862V15H22.0039L21.3389 19.3359H17.8438V29.8177C25.0147 28.6925 30.5 22.4869 30.5 15Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3389 19.3359L22.0039 15H17.8438V12.1862C17.8438 11 18.4249 9.84375 20.2882 9.84375H22.1797V6.15234C22.1797 6.15234 20.4631 5.85938 18.8219 5.85938C15.3957 5.85938 13.1562 7.93593 13.1562 11.6953V15H9.34766V19.3359H13.1562V29.8177C14.7093 30.0608 16.2907 30.0608 17.8438 29.8177V19.3359H21.3389Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.db55feadb03adb421b522eac858b09b8.svg";
export { ForwardRef as ReactComponent };